require('./RAIncomingOutgoingStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const RAInput = require('../commons/RAInput/RAInput');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    INCOMING_OUTGOING_MAX,
    RAINCOMINGS,
    RAOUTGOINGS,
} = require('../../raConstants/index');

const { EURO_SYMBOL } = require('constants/index');

class RAIncomingOutgoingStep extends React.Component {
    buildTooltip(content) {
        if (this.props.disabled) {
            return null;
        }

        return <OKTooltip content={content} offset={[0, -15]} />;
    }

    render() {
        const {
            incomingValue,
            outgoingValue,
            disabled,
            title,
            subtitle,
            explanation,
            titleTooltip,
        } = this.props;

        const firstToolTipContent = 'incomingsOutgoings-firstToolTipContent';
        const secondToolTipContent = 'incomingsOutgoings-secondToolTipContent';
        const firstTooltip = this.buildTooltip(firstToolTipContent);
        const secondToolTip = this.buildTooltip(secondToolTipContent);
        const containerRowTextClassName = classnames(
            'ra-incoming-outgoing__container__row__text',
            {
                'ra-incoming-outgoing__container__row__text--disabled': !!disabled,
            },
        );
        const incomingsRowClass = classnames(
            'ra-incoming-outgoing__container__row__incomings',
            {
                'ra-incoming-outgoing__container__row__incomings--disabled': !!disabled,
            },
        );
        const outgoingsRowClass = classnames(
            'ra-incoming-outgoing__container__row__outgoings',
            {
                'ra-incoming-outgoing__container__row__outgoings--disabled': !!disabled,
            },
        );

        return (
            <section className="ra-incoming-outgoing">
                <div className="ra-incoming-outgoing__title">
                    {title} {titleTooltip}
                </div>
                <div className="ra-incoming-outgoing__subtitle">{subtitle}</div>
                <div className="ra-incoming-outgoing__explanation">
                    {explanation}
                </div>
                <div className="ra-incoming-outgoing__container">
                    <div className="ra-incoming-outgoing__container__row">
                        <div className={containerRowTextClassName}>
                            <FormattedText value="incomingsOutgoings-incomings" />
                        </div>
                        <div className={incomingsRowClass}>
                            <RAInput
                                amount={incomingValue}
                                customClassName="ra-incoming-outgoing__input"
                                onhandleChange={this.props.updateIncomingValue}
                                min={0}
                                max={INCOMING_OUTGOING_MAX}
                                name={RAINCOMINGS}
                                showBlurZero={true}
                                maxBackEndFractionLength={2}
                                disabled={disabled}
                            />
                        </div>
                        <div className="ra-incoming-outgoing__container__row__symbol ra-incoming-outgoing__container__row__symbol--tooltip">
                            {EURO_SYMBOL}
                        </div>
                        <div className="ra-incoming-outgoing__tooltip ra-incoming-outgoing__tooltip--first">
                            {firstTooltip}
                        </div>
                    </div>
                    <div className="ra-incoming-outgoing__container__row">
                        <div className={containerRowTextClassName}>
                            <FormattedText value="incomingsOutgoings-outgoings" />
                        </div>
                        <div className={outgoingsRowClass}>
                            <RAInput
                                amount={outgoingValue}
                                customClassName="ra-incoming-outgoing__input"
                                onhandleChange={this.props.updateOutgoingValue}
                                min={0}
                                max={INCOMING_OUTGOING_MAX}
                                name={RAOUTGOINGS}
                                showBlurZero={true}
                                maxBackEndFractionLength={2}
                                disabled={disabled}
                            />
                        </div>
                        <div className="ra-incoming-outgoing__container__row__symbol ra-incoming-outgoing__container__row__symbol--tooltip">
                            {EURO_SYMBOL}
                        </div>
                        <div className="ra-incoming-outgoing__tooltip ra-incoming-outgoing__tooltip--last">
                            {secondToolTip}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

RAIncomingOutgoingStep.propTypes = {
    disabled: PropTypes.bool,
    incomingValue: PropTypes.number.isRequired,
    outgoingValue: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    explanation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    updateIncomingValue: PropTypes.func.isRequired,
    updateOutgoingValue: PropTypes.func.isRequired,
    titleTooltip: PropTypes.any,
};

module.exports = RAIncomingOutgoingStep;
